<template>
  <div>
    <h3 class="title">数据字典管理</h3>
    <el-divider></el-divider>
    <el-row class="rtl-right">
      <el-button type="primary" plain icon="el-icon-circle-plus-outline" @click="add">添加</el-button>
      <el-button type="success" plain icon="el-icon-plus" @click="cratePer">生成权限</el-button>
    </el-row>
    <!-- table-box -->
    <div class="table-box">
      <el-table
        :data="tableData" 
        border 
        style="width: 100%" 
        v-loading="loading">
        <el-table-column type="expand">
          <template slot-scope="props">
            <p v-html="props.row.value"></p>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型"></el-table-column>
        <el-table-column prop="name" label="名称" width="350"></el-table-column>
        <el-table-column prop="key" label="键"></el-table-column>
        <!-- <el-table-column prop="value" label="值"></el-table-column> -->
        <el-table-column prop="status" width="100" label="状态">
          <template slot-scope="scope">
            <label v-if="scope.row.status=='1'">开启</label>
            <label v-if="scope.row.status=='0'">关闭</label>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间"></el-table-column>
        <el-table-column label="操作" prop="dosome">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button
              v-if="1==2"
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
          </el-table-column>
      </el-table>
    </div>

    <!-- el-dialog manage-->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      top="3vh"
      width="60%"
      :before-close="handleClose">
      <div class="form-content">
        <el-form label-width="120px" :model="ruleForm" ref="ruleForm">
          <el-form-item label="图片" prop="image" v-if="showImg">
            <el-upload
              class="avatar-uploader"
              :action="imgActionUrl"
              name="image"
              :data="imageData"
              :headers="imageHeader"
              :on-success="handleImageSuccess">
              <img v-if="ruleForm.image" :src="ruleForm.image" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-input v-model="ruleForm.type" placeholder="类型" :disabled="!addDialog"></el-input>
          </el-form-item>
          <el-form-item label="名称" prop="name" class="rtl-right">
            <el-input v-model="ruleForm.name" placeholder="名称" :disabled="!addDialog"></el-input>
          </el-form-item>
          <el-form-item label="键" prop="key">
            <el-input v-model="ruleForm.key" placeholder="键"></el-input>
          </el-form-item>
          <el-form-item label="值" prop="value" v-if="!isEditor">
            <el-input v-model="ruleForm.value" placeholder="值" :disabled="valDisabled"></el-input>
          </el-form-item>
          <el-form-item label="值" prop="value" v-if="isEditor">
            <vue-ueditor-wrap v-model="ruleForm.value" :config="myConfig"></vue-ueditor-wrap>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="ruleForm.status" placeholder="状态">
              <el-option label="开启" value="1"></el-option>
              <el-option label="关闭" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" plain @click="closeDialog('ruleForm')">取消</el-button>
        <el-button type="primary" plain @click="resetForm('ruleForm')">重置</el-button>
        <el-button type="success" plain @click="submitForm('ruleForm')">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<style lang="scss" scoped>
  .avatar-uploader{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 300px;
    height: 120px;
    img{
      width: 300px;
      height: 120px;
    }
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 24px;
    color: #8c939d;
    width: 300px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
</style>

<script>
  var self;

  import baseConfig from '../base.config.js'
  var home_url = baseConfig.baseUrl + 'editor/controller.php';
  import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module

  export default {
    activated: function() {
      self = this;
      self.getList();
      self.imgActionUrl = baseConfig.imgActionUrl;
    },
    data() {
      return {
        tableData: [],
        loading: false,
        dialogVisible: false,
        ruleForm: {
          name:"",
          key:"",
          value:"",
          type:"",
          image:"",
          status:""
        },
        editIndex: -1,
        dialogTitle:"字典管理",
        addDialog:true,
        editId:"",
        imgActionUrl:"",
        imageData:{
          "folder":"test"
        },
        imageHeader:{
          'Authorization': 'Bearer ' + localStorage.getItem("token"),
          'X-Requested-With': 'XMLHttpRequest'
        },
        valDisabled:false,
        showImg:false,
        isEditor:false,
        myConfig: {
          // 编辑器不自动被内容撑高
          autoHeightEnabled: false,
          // 初始容器高度
          initialFrameHeight: 500,
          // 初始容器宽度
          initialFrameWidth: '100%',
          // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
          // serverUrl: 'http://35.201.165.105:8000/controller.php',
          // serverUrl: 'https://durdana-api.hamdam.biz/editor/controller.php',
          serverUrl: home_url,
          // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
          UEDITOR_HOME_URL: '/UEditor/'
        }
      };
    },
    methods: {
      getList() {
        self.loading = true;
        self.$fetch("admin/dictionary").then(response => {
          if (response.status == 200) {
            self.tableData = response.data.data;
          } else{
            console.log(response.message);
          }
          self.loading = false;
        }).catch(err => {
          console.log('××××××××××××××');
          self.loading = false;
        });
      },
      add() {
        self.addDialog = true;
        self.dialogTitle = "添加";
        self.dialogVisible = true;
      },
      handleEdit(index, row) {
        console.log(row);
        self.addDialog = false;
        self.dialogTitle = "编辑";

        if(row.type == 'image'){
          self.valDisabled = true;
          self.showImg = true;
          self.ruleForm.image = row.value;
          self.isEditor = false;
        }else if(row.type == 'text'){
          self.valDisabled = false;
          self.showImg = false;
          self.isEditor = true;
        }else if(row.type == 'link'){
          self.valDisabled = false;
          self.showImg = false;
          self.isEditor = false;
        }else if(row.type == 'string'){
          self.valDisabled = false;
          self.showImg = false;
          self.isEditor = false;
        }

        self.editId = row.id;
        self.ruleForm.name = row.name;
        self.ruleForm.key = row.key;
        self.ruleForm.value = row.value;
        self.ruleForm.type = row.type;
        self.ruleForm.status = row.status + '';
        self.dialogVisible = true;
      },
      handleDelete(index, row) {
        self.$confirm("确认删除？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          self.$remove('admin/dictionary/'+row.id).then((response) => {
            console.log(response);
            if(response.status == 204){
              self.getList();
              self.$message({
                message: "删除完成",
                type: "success",
                duration: 1200
              });
            }else{
              console.log(response);
            }
          }).catch(err => {
            console.log('××××××××××××××××');
          });

        }).catch(() => {
          self.$message({
            type: "info",
            message: "取消删除"
          });
        });
      },
      submitForm(formName) {
        var data = {
          name:self.ruleForm.name,
          key:self.ruleForm.key,
          value:self.ruleForm.value,
          type:self.ruleForm.type,
          status:self.ruleForm.status
        }
        if(self.addDialog){
          self.$post('admin/dictionary',data).then((response) => {
            if(response.status == 201){
              self.closeDialog(formName);
              self.getList();
              self.$message({
                message: response.data.message,
                type: "success",
                duration: 1200
              });
            }else{
              console.log(response.data.message);
            }
          }).catch(err => {
            console.log('××××××××××××××');
          });
        }else{
          self.$put('admin/dictionary/'+self.editId,data).then((response) => {
            if(response.status == 201){
              self.closeDialog(formName);
              self.getList();
              self.$message({
                message: response.data.message,
                type: "success",
                duration: 1200
              });
            }else{
              self.$message({
                message: response.data.message,
                type: "warning",
                duration: 1500
              });
            }
          }).catch(err => {
            console.log('××××××××××××××');
          });
        }
      },
      resetForm(formName) {
        self.$refs[formName].resetFields();
        self.ruleForm = {
          name:"",
          key:"",
          value:"",
          type:"",
          image:"",
          status:""
        }
        self.valDisabled = false;
      },
      closeDialog(formName) {
        self.resetForm(formName);
        self.dialogVisible = false;
      },
      handleClose(done) {
        done();
        self.resetForm("ruleForm");
      },
      handleImageSuccess(res, file) {
        console.log(res.data.image);
        self.ruleForm.image = res.data.image;
        if(self.ruleForm.type == "image"){
          self.valDisabled = true;
          self.ruleForm.value = self.ruleForm.image;
        }
      },
      cratePer(){
        self.$post('admin/permissions').then((response) => {
          if(response.status == 201){
            self.$message({
              message: response.data.message,
              type: "success",
              duration: 1200
            });
          }else{
            console.log(response.data.message);
          }
        }).catch(err => {
          console.log('××××××××××××××');
        });
      }
    },
    components: {
      VueUeditorWrap
    },
    deactivated(){
      self.valDisabled = false;
    }
  };
</script>

